import React, { useMemo } from 'react';
import useChatWidgetStore from '@/widget/services/useChatWidgetStore';
import ChatWidgetContext, { SettingsType } from '@/widget/services/useChatWidgetContext';
import ChatWidget from './ChatWidget';

function ChatWidgetWrapper({ settings, initialState }: {
  settings: SettingsType,
  initialState: {
    open: boolean;
    previousMode: 'main' | 'list',
    mode: 'main' | 'list' | 'conversation';
    userId: number | null;
    accountId: number | null;
    orgName: string | null;
  }
}) {
  const store = useChatWidgetStore(initialState);
  const contextValue = useMemo(() => ({
    settings, store,
  }), [settings, store]);

  return (
    <ChatWidgetContext.Provider value={contextValue}>
      <ChatWidget />
    </ChatWidgetContext.Provider>
  );
}

export default ChatWidgetWrapper;
